import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_MEMBERSHIP_PPMU_ENABLED_FOR = createFcmConfig('membership_ppmu_enabled_for', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
